export class LoginUser {
    Employee_Number!: number;
    Name!: string;
    Cost_Center!: string;
    Department!: string;
    Position!: string;
    Work_Location!: string;
    Employee_CAI!: string;
    Supervisor_Number ? : number  ;
    Supervisor_Name!: string;
    YAP001!: string;
    Date_Updated ?: number ;
    YAPSAL ?: number ;
    Email!: string;
    Role!: string;
    ProvisioningID! : string;
}
